export default {
	id: null,
	year: null,
	make: null,
	model: null,
	sizes: [],
	image: null,
	show_vehicle: null
}